import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import '@/utils/filter'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import './styles/reset.css'
import '@/styles/sass/comment.scss'
import '@/styles/sass/plugin.scss'
import { Input, Radio, Checkbox, CheckboxGroup, RadioGroup, Switch, Message, MessageBox, Alert, Tooltip, Dialog, Popover,
  Pagination, Upload,  Tabs, TabPane, Table, TableColumn, Autocomplete, Scrollbar, Form, FormItem, Select,
  Option, DatePicker, Loading} from 'element-ui'

import { get, post, uploadfile, remove, put } from './utils/request'
import { getEmiApi, postEmiApi, uploadfileEmiApi, removeEmiApi, putEmiApi } from './utils/request'
import TokenManager from '@/utils/auth'
import { getEmojis, parseEmoji } from 'wechat-emoji-parser'
import VChart from 'vue-echarts'

Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$remove = remove
Vue.prototype.$put = put
Vue.prototype.$uploadfile = uploadfile

// 注册EMI API服务器的请求方法
Vue.prototype.$getEmiApi = getEmiApi
Vue.prototype.$postEmiApi = postEmiApi
Vue.prototype.$removeEmiApi = removeEmiApi
Vue.prototype.$putEmiApi = putEmiApi
Vue.prototype.$uploadfileEmiApi = uploadfileEmiApi

// 重写 $message 方法以应用自定义样式
Vue.prototype.$message = function(options) {
  if (typeof options === 'string') {
    options = { message: options }
  }
  
  // 计算屏幕高度的一半，使消息显示在屏幕中央
  const h = window.innerHeight / 2
  
  return Message({
    message: options.message,
    type: options.type || 'info',
    duration: options.duration || 1000, // 延长显示时间到3秒
    offset: options.offset || h,
    showClose: true, // 显示关闭按钮
    center: true, // 水平居中
    dangerouslyUseHTMLString: true, // 允许HTML内容
    customClass: 'custom-message' // 自定义样式类
  })
}

// 为 $message 添加便捷方法
Vue.prototype.$message.success = function(message, duration) {
  return Vue.prototype.$message({ message, type: 'success', duration })
}

Vue.prototype.$message.warning = function(message, duration) {
  return Vue.prototype.$message({ message, type: 'warning', duration })
}

Vue.prototype.$message.error = function(message, duration) {
  return Vue.prototype.$message({ message, type: 'error', duration })
}

Vue.prototype.$message.info = function(message, duration) {
  return Vue.prototype.$message({ message, type: 'info', duration })
}

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$prompt = MessageBox.prompt

// 阻止启动生产消息.
Vue.config.productionTip = false

Vue.use(Input)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(Switch)
Vue.use(Alert)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Autocomplete)
Vue.use(Scrollbar)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service


// 全局注册Vue-ECharts组件
Vue.component('v-chart', VChart)

// 全局混入方法
Vue.mixin({
  beforeMount () {

  },
  methods: {
    /**
         * @param msg - 传入文本
         * @param type - 弹框类型，默认警告
         * @param time - 显示时间，默认1秒
         * @param offset - 弹框位置，默认屏幕中间
         */
    Message (msg, type, time, offset) {
      // 直接调用重写后的 $message 方法，保持向后兼容
      return this.$message({
        message: msg,
        type: type || 'warning',
        duration: time || 1000,
        offset: offset
      })
    }
  }
})


// 全局注册 getEmojis 方法
Vue.prototype.$getEmojis = () => {
  return getEmojis({ size: 24 });
};

// 全局注册 parseEmoji 方法
Vue.prototype.$parseEmoji = (text) => {
  if (!text) return '';
  return parseEmoji(text, {});
};

router.beforeEach((to, from, next) => {
    if (to.name === 'Login') {
        next();
        return;
    }
    
    const token = store.getters.getToken || TokenManager.getToken();
    if (token) {
        next();
    } else {
        localStorage.setItem('redirectPath', to.fullPath);
        next('/login');
    }
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})